import eHorizonImg from "../../../assets/images/Events/E-Horizon-2025.jpg";
import annualDayImg from "../../../assets/images/Events/Annual Day.png";
import sportsDayImg from "../../../assets/images/Events/Sports Day.jpg";
import swaramImg from "../../../assets/images/Events/Swaram 2025.jpg";

const eventsData = [
    {
        id: 1,
        image: eHorizonImg,
        date: "February 19-26, 2026",
        title: "E-Horizon 2026 - Technical Symposium",
    },
    {
        id: 2,
        image: swaramImg,
        date: "February 25, 2026",
        title: "Swaram 2026 - Cultural Fest",
    },
    {
        id: 3,
        image: sportsDayImg,
        date: "March 16, 2026",
        title: "Sports Day",
    },
    {
        id: 4,
        image: annualDayImg,
        date: "March 18, 2026",
        title: "Annual Day",
    },
];

export default eventsData;
